import { createGlobalStyle, css } from 'styled-components';

const globalCSS = css`
  body,
  html,
  #root {
    margin: 0;
    padding: 0;
    min-width: 100%;
    min-height: 100vh;

    @supports (-webkit-touch-callout: none) {
      min-height: -webkit-fill-available;
    }
  }

  body {
    font-family: 'Noto Sans CJK KR', 'KoPubBatang_Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  * {
    box-sizing: border-box;
  }
`;

export default createGlobalStyle`${globalCSS}`;
